import i18n from "i18next";
const getUserTimeZone = (): string | undefined => {
  const savedTimeZone =
    localStorage.getItem("time_zone") || sessionStorage.getItem("time_zone");
  return savedTimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
};

type Headers = {
  "Content-Type": string;
  "Accept-Language"?: string;
  Authorization?: string;
  "User-Timezone"?: string;
  [key: string]: string | undefined;
};

export const buildHeaders = (
  additionalHeaders: Record<string, string | undefined> = {},
): Headers => {
  const token =
    localStorage.getItem("accessToken") ||
    sessionStorage.getItem("accessToken");

  const headers: Headers = {
    "Content-Type": "application/json",
    ...additionalHeaders,
  };

  // Remove keys explicitly set to undefined (e.g. for multipart uploads)
  (Object.keys(headers) as (keyof Headers)[]).forEach((key) => {
    if (headers[key] === undefined) delete headers[key];
  });

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const timezone = getUserTimeZone();
  if (timezone) {
    headers["User-Timezone"] = timezone;
  }
  const currentLang = i18n.language;
  if (currentLang) {
    headers["Accept-Language"] = currentLang;
  }

  return headers;
};
